import React from "react";
import CardBody from "../../../material-kit/components/Card/CardBody";
import Card from "../../../material-kit/components/Card/Card";
import Box from "@material-ui/core/Box";
import {makeStyles} from "@material-ui/styles";
import {grayColor} from "../../../material-kit/assets/jss/material-kit-pro-react";

const useStyles = makeStyles({
  card: {
    margin: "8px 0",
    paddingBottom: "8px"
  },
  title: {
    marginTop: 10,
    color: "rgb(12,66,105)",
    fontSize: "1rem",
    textTransform: "uppercase",
    fontWeight: 500
  },
  notes: {
    marginTop: "4px",
    color: grayColor[1],
    fontSize: "0.75rem"
  }
});

function Section({title, notes, htmlNotes, children}) {

  const classes = useStyles();

  return (
      <Card className={classes.card}>
        <CardBody>
          {title && <Box className={classes.title}>{title}</Box>}
          {notes ? <Box className={classes.notes}>{notes}</Box> : null}
          {htmlNotes ? <div dangerouslySetInnerHTML={{__html:htmlNotes}}></div> : null}
          {children}
        </CardBody>
      </Card>
  );

}

export default Section;